import { HTMLProps, forwardRef } from 'react';

export type SidebarSectionActionProps = HTMLProps<HTMLDivElement>;

const SidebarSectionAction = forwardRef<
  HTMLDivElement,
  SidebarSectionActionProps
>((props, ref) => {
  const { className, children, ...rest } = props;

  return (
    <div {...rest} ref={ref} data-testid="action-button" className={className}>
      {children}
    </div>
  );
});

SidebarSectionAction.displayName = 'SidebarSection.Action';

export default SidebarSectionAction;
